/* BrandNest 6.0: accessible overflow controls for LTR and RTL category menus. */
(() => {
  'use strict';
  const mounted = new WeakMap();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function mount(shell) {
    if (mounted.has(shell)) return;
    const track = shell.querySelector('[data-bn-nav-track]');
    const previous = shell.querySelector('[data-bn-nav-step="-1"]');
    const next = shell.querySelector('[data-bn-nav-step="1"]');
    if (!track || !previous || !next) return;
    let pending = 0;
    function update() {
      pending = 0;
      const links = track.querySelectorAll('a');
      if (!links.length) return;
      const overflow = track.scrollWidth > shell.clientWidth + 1;
      previous.hidden = next.hidden = !overflow;
      if (!overflow) return;
      const rtl = getComputedStyle(track).direction === 'rtl';
      const boundary = track.getBoundingClientRect();
      const first = links[0].getBoundingClientRect();
      const last = links[links.length - 1].getBoundingClientRect();
      previous.disabled = rtl ? first.right <= boundary.right + 2 : first.left >= boundary.left - 2;
      next.disabled = rtl ? last.left >= boundary.left - 2 : last.right <= boundary.right + 2;
    }
    function queue() { if (!pending) pending = requestAnimationFrame(update); }
    function click(event) {
      const button = event.target.closest('[data-bn-nav-step]');
      if (!button || button.disabled || !shell.contains(button)) return;
      const rtl = getComputedStyle(track).direction === 'rtl';
      const step = Number(button.dataset.bnNavStep);
      const amount = Math.max(140, track.clientWidth * .7) * step * (rtl ? -1 : 1);
      track.scrollBy({left:amount,behavior:reducedMotion() ? 'instant' : 'smooth'});
    }
    shell.addEventListener('click',click);
    track.addEventListener('scroll',queue,{passive:true});
    const observer = new ResizeObserver(queue);
    observer.observe(shell);
    observer.observe(track);
    const mutation = new MutationObserver(queue);
    mutation.observe(track,{childList:true,subtree:true,characterData:true});
    mounted.set(shell, {queue,destroy() {
      observer.disconnect();mutation.disconnect();cancelAnimationFrame(pending);
      shell.removeEventListener('click',click);track.removeEventListener('scroll',queue);mounted.delete(shell);
    }});
    queue();
  }
  function initialise(root = document) {
    if (root.matches?.('[data-bn-nav-shell]')) mount(root);
    root.querySelectorAll?.('[data-bn-nav-shell]').forEach(mount);
  }
  initialise();
  document.addEventListener('shopify:section:load',event => initialise(event.target));
  document.addEventListener('shopify:section:unload',event => {
    event.target.querySelectorAll('[data-bn-nav-shell]').forEach(shell => mounted.get(shell)?.destroy());
  });
  document.addEventListener('brandnest:languagechange',() => {
    document.querySelectorAll('[data-bn-nav-shell]').forEach(shell => {
      const track = shell.querySelector('[data-bn-nav-track]');
      track.scrollLeft = 0;
      mounted.get(shell)?.queue();
    });
  });
  document.fonts?.ready.then(() => document.querySelectorAll('[data-bn-nav-shell]').forEach(shell => mounted.get(shell)?.queue()));
})();
